import logoAllusedparts from './components/Logo/allusedparts.png'
import logoAutoenginesoutlet from './components/Logo/autoenginesoutlet.svg'
import logoAutomotix from './components/Logo/automotix-hires-logo.svg'
import logoBuyusedengine from './components/Logo/buyusedengine.png'

type IPortalTitle = 'automotix' | 'allusedparts' | 'autoenginesoutlet' | 'buyusedengine'
interface IPortalSetting {
  logo: string
  icon: string
  title: string
  description: string
  agreementUrl: string
}
type IPortal = Record<IPortalTitle, IPortalSetting>

const portals: IPortal = {
  automotix: {
    logo: logoAutomotix,
    icon: logoAutomotix,
    title: 'Automotix',
    description: 'Automotix',
    agreementUrl: 'https://automotix.net/return-policy.html',
  },
  allusedparts: {
    logo: logoAllusedparts,
    icon: logoAllusedparts,
    title: 'Allusedparts',
    description: 'Allusedparts',
    agreementUrl: 'https://allusedparts.com/returns.html',
  },
  autoenginesoutlet: {
    logo: logoAutoenginesoutlet,
    icon: logoAutoenginesoutlet,
    title: 'Autoenginesoutlet',
    description: 'Autoenginesoutlet',
    agreementUrl: 'https://automotix.net/return-policy.html',
  },
  buyusedengine: {
    logo: logoBuyusedengine,
    icon: logoBuyusedengine,
    title: 'Buyusedengine',
    description: 'Buyusedengine',
    agreementUrl: 'https://shop.buyusedengine.com/returns.html',
  },
}

export const SETTING = {
  authHistoryStorageTitle: 'auth-params-history',
  portals,
  currentPortal:
    portals[
    (Object.keys(portals).find((title) =>
      window.location.origin.includes(title),
    ) as IPortalTitle) || 'automotix'
    ],
  maxFilesSizeMb: 20,
  filesTypes: {
    jpeg: 'image/jpeg',
    jpg: 'image/jpg',
    png: 'image/png',
    webp: 'image/webp',
    gif: 'image/gif',
    svg: 'image/svg+xml',
    pdf: 'application/pdf',
    doc: 'application/msword',
    zip: 'application/x-zip-compressed',
    xls: 'application/vnd.ms-excel',
    docx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xlsx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    rar: '',
    mp4: 'video/mp4',
    HEIC: 'image/heif',
    MOV: 'video/quicktime',
  },
}
